<template>
  <div>
    <div class="uk-grid-medium" uk-grid>
      <div class="uk-width-5-5">
        <div class="d-flex">
          <nav id="breadcrumbs" class="mb-3">
            <ul>
              <li>
                <a href="#"> <i class="uil-home-alt"></i> </a>
              </li>
              <li>{{ $t("institution.list.company") }}</li>
              <li>{{ $t("general.edit") }}</li>
            </ul>
          </nav>
        </div>

        <div v-if="loading" class="card">
          <default-loading />
        </div>
        <template v-else>
          <div class="card">
            <div v-for="error in errorMessages" v-if="errorMessages" class="uk-alert-danger" uk-alert>
              <a class="uk-alert-close" uk-close></a>
              <p style="color: red">
                <i class="uil-exclamation-triangle"></i> {{ error }}
              </p>
            </div>
            <div v-if="successMessage" class="uk-alert-success" uk-alert>
              <a class="uk-alert-close" uk-close></a>
              <p style="color: green">
                <i class="uil-exclamation-triangle"></i>
                {{ successMessageText || $t("general.update_success") }}
              </p>
            </div>
          </div>
          <div class="card row">
            <div class="uk-grid uk-child-width-1-2 uk-padding" uk-grid>
              <div>
                <h4>
                  <i class="uil-user-circle"></i>
                  {{ $t("institution.information") }}
                </h4>
                <div class="form-group row mb-3">
                  <label class="col-md-12 col-form-label" for="filename">{{
                    $t("institution.avatar")
                  }}<span class="required">*</span></label>
                  <div class="col-md-12">
                    <div class="position-relative d-flex justify-center justify-content-center align-items-center">
                      <img :src="item.logo_link" alt="" class="logoarea rounded img-thumbnail mb-2" />
                      <input id="logo" ref="logo" accept="image/*" class="d-none" name="filename" type="file"
                        @change="processFile($event)" />
                      <button class="btn btn-sm btn-outline-primary ml-2" type="button" @click="inputClick()">
                        {{ $t("general.image_change") }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-3">
                  <label class="col-md-12 col-form-label" for="filename">{{ $t('general.login_screen_image') }}</label>
                  <div class="col-md-12">
                    <div class="position-relative d-flex justify-center justify-content-center align-items-center">
                      <img v-if="item.login_images" :src="loginImageSrc" alt=""
                        class="logoarea2 rounded img-thumbnail mb-2" />
                      <img v-else alt="" class="logoarea2 rounded img-thumbnail mb-2"
                        src="@/assets/images/no-photo.png" />
                      <input id="loginLogo" ref="loginLogo" accept="image/*" class="d-none" name="filename" type="file"
                        @change="processFileLogin($event)" />
                      <button class="btn btn-sm btn-outline-primary ml-2" type="button" @click="inputLoginLogoClick()">
                        {{ $t('general.image_change') }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="name">{{
                      $t("institution.list.company_name")
                    }}<span class="required">*</span></label>
                    <input id="name" v-model="item.name" class="form-control" name="name" placeholder="" required=""
                      type="text" />
                  </div>
                </div>

                <div v-if="$isSuperAdmin" class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="start_date">{{
                      $t("institution.contract_start_date")
                    }}<span class="required">*</span></label>
                    <input v-if="item.contract" id="start_date" v-model="item.contract.start_date" class="form-control"
                      name="start_date" placeholder="" required="" type="date" />
                  </div>
                </div>

                <div v-if="$isSuperAdmin" class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="end_date">{{
                      $t("institution.list.contract_expired_date")
                    }}<span class="required">*</span></label>
                    <input v-if="item.contract" id="end_date" v-model="item.contract.end_date"
                      :min="item.contract.start_date" class="form-control" name="end_date" placeholder="" required=""
                      type="date" />
                  </div>
                </div>

                <div v-if="$isSuperAdmin" class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="domain">{{
                      $t("institution.domain_name")
                    }}<span class="required">*</span></label>
                    <input id="domain" v-model="item.domain" class="form-control" name="domain" placeholder="" required=""
                      type="text" />
                  </div>
                </div>

                <div v-if="$isSuperAdmin" class="form-group row domain uk-first-column">
                  <div class="col-md-12">
                    <label class="col-form-label">{{ $t("institution.alias_name") }}<span
                        class="required">*</span></label>
                    <div class="d-flex">
                      <input id="alias" v-model="item.alias" class="form-control" name="alias"
                        :placeholder="$t('general.alias')" type="text" />
                      <span>.softinya.com</span>
                    </div>
                  </div>
                </div>

                <!-- <div class="form-group row" v-if="isAdmin">
                <div class="col-md-12">
                  <label class="col-form-label" for="domain">Anzera Eğitim Pini</label>
                  <input type="text" class="form-control" v-model="item.pin" placeholder="" required="" />
                </div>
              </div> -->

                <!-- Üst Kurum -->
                <div v-if="$isSuperAdmin" class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="domain">{{ $t('general.parent_institution') }}</label>
                    <div class="form-group row">
                      <div class="col-md-12">
                        <multiple-select-input :model.sync="company" :required="false" :searchable="true"
                          :values="institutions" @select="parentCompanyId = $event.id" />

                        <!-- Alt kuruma kullanıcı ekleme butonu -->
                        <button v-if="effectiveParentCompanyId" class="btn btn btn-outline-secondary btn-block"
                          type="button" uk-toggle="target: #modal_user_group_add">
                          <i class="uil-plus"></i> {{ $t('general.add_users') }} - ( {{ $t('general.from_parent_institution_users') }} )
                        </button>

                        <!-- Seçili kullanıcılar -->
                        <div v-if="effectiveParentCompanyId && checked_users_list?.length" class="mt-3">
                          <label class="col-form-label"><strong> {{ $t('general.selected_users') }} :</strong></label>
                          <div class="selected-users-list">
                            <span v-for="(user, index) in checked_users_list" :key="user.id" class="user-badge">
                              {{ user.fullname }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <CatalogTrainingList v-model="self_registrable_training_ids" :catalog-loading="catalogLoading"
                  :items="catalogItems" :per-page.sync="filters.perPage" :show-add-as-contents="true"
                  :show-per-page="true" :training-purchase-registration.sync="training_purchase_registration"
                  @apply-filter="onCatalogFilter" @add-as-contents="addSelectedItemsAsContents" />
              </div>
            </div>

            <div class="uk-card-footer pt-0">
              <div class="float-right">
                <button class="btn btn-primary btn-sm mt-2" type="button" @click="saveForm()">
                  <i class="uil-check"></i> {{ $t("general.save") }}
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div id="modal_user_group_add" class="uk-modal-full uk-modal" uk-modal="">
      <div class="uk-modal-footer bggray">
        <h3 class="float-left">
          <i class="uil-presentation-plus"></i>
          {{ $t('general.add_users') }}
        </h3>
        <button class="uk-button uk-button-default
                    small
                    uk-modal-close
                    float-right
                  " type="button">
          <i class="uil-times"></i> {{ $t("general.close") }}
        </button>
      </div>

      <div class="uk-modal-dialog bggray h-100">
        <div class="uk-padding-large position-relative uk-grid pt-0" uk-grid="">
          <div class="uk-width-5-5">
            <UserGroupSelection :key="'user-selection-' + effectiveParentCompanyId" :added_users="checked_users"
              :allow_both_selection="true" :company_id="effectiveParentCompanyId" :is-groups-active="false"
              :with_description="true" class="bg-white px-2 py-4 card"
              @setCheckedUsers="($event) => { checked_users = $event.ids, checked_users_list = $event.items; }" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import UserGroupSelection from "@/view/components/assignment/UserGroupSelection.vue";
import CatalogTrainingList from "@/view/company/Institution/components/CatalogTrainingList.vue";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";
import module, {
  BASE_URL,
  GET_ITEM,
  ITEM,
  MODULE_NAME,
  ERROR,
  LOADING,
  UPDATE_ITEM,
} from "@/core/services/store/company.module";
import store from "@/core/services";
import $ from "jquery";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import Pagination from "@/view/components/dataTable/Pagination";
import {
  GET_ITEMS,
} from "@/core/services/store/REST.module";
import axios from "axios";
import company_module, {
  BASE_URL as COMPANY_BASE_URL,
  GET_ITEMS as GET_INSTITUTIONS,
  MODULE_NAME as COMPANY_MODULE,
  ITEMS as INSTITUTIONS,
} from "@/core/services/store/company.module";

const _COMPANY_MODULE_NAME = COMPANY_MODULE;

export default {
  name: "InstitutionEdit",
  components: {
    UserGroupSelection,
    DefaultLoading,
    Pagination,
    MultipleSelectInput,
    CatalogTrainingList,
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(MODULE_NAME, module);
    registerStoreModule(_COMPANY_MODULE_NAME, company_module);
  },
  data() {
    return {
      training_purchase_registration: false,
      imageLogoInput: null,
      imageLoginInput: null,
      loginImageInputs: {},
      loginImagePreviewUrls: {},
      successMessage: false,
      successMessageText: '',
      errorMessages: [],
      search: null,
      searchResult: [],
      options: [0],
      kinds: [0],
      sort: "desc",
      restUrl: "api/training",
      educationTypes: [],
      selected_type: {
        id: null,
        name: this.$t("education.all_categories"),
      },
      filters: {
        page: 1,
        search: "",
        training_type_id: 0,
        training_kind_id: 0,
        admin_page: true,
        can_show_self_registrable_trainings: true,
        company_id: "",
        perPage: 10
      },
      isProcessing: false,
      selected_type_name: null,
      trainingCategoryUrl: "api/training-type",
      self_registrable_training_ids: [],
      company: {
        id: null,
        name: null,
      },
      parentCompanyId: null,
      institutions: [],
      checked_users: [],
      checked_users_list: [],
      catalogItems: null,
      catalogLoading: false,
    };
  },
  computed: {
    item: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEM];
      },
      set(value) {
      },
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    loading() {
      return store.getters[MODULE_NAME + "/" + LOADING];
    },
    currentLanguage() {
      return String((this.$i18n && this.$i18n.locale) || this.secureLocalStorage("language") || "tr").toLowerCase();
    },
    effectiveParentCompanyId() {
      return this.parentCompanyId;
    },
    loginImageSrc() {
      const images = {
        ...(this.item?.login_images || {}),
        ...this.loginImagePreviewUrls,
      };
      if (!Object.keys(images).length) return '';
      return (
        images[this.currentLanguage] ||
        images.tr ||
        Object.values(images).find(Boolean) ||
        ''
      );
    },
  },
  methods: {
    getInstitutions() {
      this.$store.dispatch(COMPANY_MODULE + "/" + GET_INSTITUTIONS, {
        url: COMPANY_BASE_URL,
        filters: {
          all: "all",
        },
      }).then((response) => {
        this.institutions = response
      });
    },
    formattedInstitution() {
      let results = [
        {
          id: null,
          name: this.$t("general.choose"),
        },
      ];
      if (this.institutions === null) return [];

      this.institutions.forEach((item) => {
        results.push({
          id: item.id,
          name: item.name,
        });
      });
      return results;
    },
    addSelectedItemsAsContents() {
      if (this.isProcessing) {
        this.errorMessages = [this.$t('general.transaction_in_progress')];
        this.scrollToTop();
        return;
      }

      this.isProcessing = true;
      this.errorMessages = [];
      this.successMessage = false;
      this.successMessageText = '';

      axios.post(`api/company/add-catalogs-as-content/${this.$route.params.id}`, {
        self_registrable_training_ids: [...new Set(this.self_registrable_training_ids)]
      })
        .then(response => {
          if (response.status >= 200 && response.status < 300) {
            this.successMessage = true;
            this.successMessageText = response.data || '';
            this.errorMessages = [];
          } else {
            this.errorMessages = [response.data || response.data.message || this.$t('general.error_occurred')];
          }
          this.scrollToTop();
        })
        .catch(error => {
          this.errorMessages = [error.response?.data?.message || this.$t('general.error_occurred')];
          this.scrollToTop();
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
    onCatalogFilter(filterData) {
      this.$set(this.filters, "page", filterData.page);
      if (!(this.options.length === 1 && this.options[0] === 0)) {
        this.$set(this.filters, "training_type_id[]", this.options);
      }
      if (!(this.kinds.length === 1 && this.kinds[0] === 0)) {
        this.$set(this.filters, "training_kind_id[]", this.kinds);
      }
      this.$set(this.filters, "search", filterData.search);
      this.$set(this.filters, "order_by", filterData.order_by);
      // Kurum düzenleme sayfasında katalog eğitimleri için istekleri
      // REST store üzerinden değil, direkt axios ile yapıyoruz.
      this.catalogLoading = true;

      axios.get(this.restUrl, {
        params: {
          page: this.filters.page,
          search: this.filters.search,
          training_type_id: this.filters.training_type_id,
          training_kind_id: this.filters.training_kind_id,
          admin_page: this.filters.admin_page,
          can_show_self_registrable_trainings: this.filters.can_show_self_registrable_trainings,
          company_id: this.filters.company_id,
          perPage: this.filters.perPage,
          order_by: this.filters.order_by,
        },
      })
        .then((response) => {
          this.catalogItems = response.data;

          if (response.data?.data) {
            response.data.data.forEach((training) => {
              training.self_registrable_trainings.forEach((data) => {
                if (
                  Number(data.pivot.company_id) ===
                  Number(this.filters.company_id)
                ) {
                  this.self_registrable_training_ids.push(
                    data.pivot.training_id
                  );
                }
              });
            });
          }
        })
        .catch(() => {
          this.catalogItems = null;
        })
        .finally(() => {
          this.catalogLoading = false;
        });
    },
    saveForm() {
      let item = this.item;
      this.errorMessages = [];
      this.successMessage = false;
      this.successMessageText = '';
      this.scrollToTop();
      if (item.name.length === 0) {
        this.errorMessages.push(this.$t("institution.required.name"));
        return false;
      }
      if (item.domain.length === 0) {
        this.errorMessages.push(this.$t("institution.required.domain"));
        return false;
      }
      if (item.alias.length === 0) {
        this.errorMessages.push(this.$t("institution.required.alias"));
        return false;
      }
      if (item.contract.end_date.length === 0) {
        this.errorMessages.push(this.$t("institution.required.end_date"));
        return false;
      }

      let formData = new FormData();
      formData.append("avatar", this.$refs.logo.files[0] ?? this.imageLogoInput);
      formData.append("name", item.name);
      formData.append("domain", item.domain);
      formData.append("alias", item.alias);
      formData.append("start_date", item.contract.start_date);
      formData.append("end_date", item.contract.end_date);
      formData.append("company", item.id);
      formData.append("pin", item.pin);
      formData.append("training_purchase_registration", this.training_purchase_registration ? 1 : 0);

      formData.append("parentCompanyId", this.effectiveParentCompanyId ?? '');

      const pendingLoginImages = Object.entries(this.loginImageInputs).filter(([, file]) => !!file);
      if (pendingLoginImages.length) {
        pendingLoginImages.forEach(([lang, file]) => {
          formData.append(`login_images[${lang}]`, file);
        });
      } else {
        formData.append('login_images', []);
      }

      // formData.append('login_images[' + this.secureLocalStorage("language") + ']', form.loginLogo);

      if (this.checked_users && this.checked_users.length) {
        for (let i = 0; i < this.checked_users.length; i++) {
          formData.append("user_ids[]", this.checked_users[i]);
        }
      }

      // if (this.allTraining) {
      //   formData.append("self_registrable_training_ids", "all");
      // } else {
      for (let i = 0; i < this.self_registrable_training_ids.length; i++) {
        formData.append(
          "self_registrable_training_ids[]",
          this.self_registrable_training_ids[i]
        );
      }
      // }
      store
        .dispatch(MODULE_NAME + "/" + UPDATE_ITEM, {
          url: BASE_URL + "/" + this.$route.params.id,
          contents: formData,
          returnType: "stateless",
          acceptPromise: true,
        })
        .then((response) => {
          if (!this.error) {
            this.successMessage = true;
            this.successMessageText = response?.data || '';
          } else this.errorMessages.push(this.error);
        });
    },
    processFile(event) {
      this.imageLogoInput = event.target.files[0];
      if (!this.imageLogoInput.type.includes("image/")) {
        this.errorMessages.push(this.$t("general.required_institution_logo"));
        return false;
      }
      let blob = URL.createObjectURL(this.imageLogoInput);
      let imageHolder = $(".logoarea");
      imageHolder.attr("src", blob);
    },
    processFileLogin(event) {
      const file = event.target.files[0];
      if (!file) {
        return false;
      }
      this.imageLoginInput = file;
      if (!file.type.includes('image/')) {
        this.errorMessages.push(this.$t('general.required_institution_logo'));
        return false
      }
      const currentPreview = this.loginImagePreviewUrls[this.currentLanguage];
      if (currentPreview && currentPreview.startsWith('blob:')) {
        URL.revokeObjectURL(currentPreview);
      }
      const blob = URL.createObjectURL(file);
      this.$set(this.loginImageInputs, this.currentLanguage, file);
      this.$set(this.loginImagePreviewUrls, this.currentLanguage, blob);
      event.target.value = null;
    },
    inputClick() {
      $("#logo").click();
    },
    inputLoginLogoClick() {
      $('#loginLogo').click();
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  watch: {
    company: {
      handler(val) {
        if (!val || !val.id) {
          this.parentCompanyId = null;
        }
      },
      deep: true,
    },
    item: {
      handler(val) {
        if (val && val.parent) {
          this.company = {
            id: val.parent.id,
            name: val.parent.name,
          };
          this.parentCompanyId = val.parent.id;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    if (!this.$isSuperAdmin) {
      this.$router.push('/403');
    }
    this.filters.company_id = this.$route.params.id;
    store.dispatch(MODULE_NAME + "/" + GET_ITEM, {
      url: BASE_URL + "/" + this.$route.params.id,
    });
    this.$store
      .dispatch(GET_ITEMS, {
        url: this.trainingCategoryUrl,
        acceptPromise: true,
      })
      .then((response) => {
        if (response.status) {
          self.educationTypes = response.data;
          self.educationTypes.unshift({
            id: 0,
            name: this.$t("education.all_categories"),
          });
        }
      });
    this.getInstitutions();
  },
  beforeDestroy() {
    Object.values(this.loginImagePreviewUrls).forEach((url) => {
      if (typeof url === 'string' && url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    });
  },
};
</script>

<style scoped>
.uk-alert {
  margin: 0;
}

/* Seçili Kullanıcılar Listesi */
.selected-users-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.user-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background-color: #3e416d;
  color: white;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.user-badge:hover {
  background-color: #2d3154;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.alert {
  padding: 12px 15px;
  border-radius: 6px;
  margin-bottom: 15px;
  border: 1px solid;
}

.alert-info {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
}
</style>
